document.addEventListener("DOMContentLoaded", function () {
  const cards = Array.from(
    new Set(
      Array.from(
        document.querySelectorAll(".filter-target-item, .experience-card-item")
      ).map((el) => el.closest(".card-item") || el)
    )
  );

  if (!cards.length) return;

  const buttons = Array.from(document.querySelectorAll(".filter-button"));
  const modalities = Array.from(document.querySelectorAll(".filter-modality"));
  const wayChecks = Array.from(document.querySelectorAll(".filter-way"));
  const categoryChecks = Array.from(document.querySelectorAll(".filter-category"));
  const rangeWraps = Array.from(document.querySelectorAll(".js-range-bar"));
  const clearFilterButtons = Array.from(
    document.querySelectorAll(".js-clear-filters")
  );

  const applyBtn = document.getElementById("applyFiltersBtn");
  const sidebar = document.getElementById("filtersSidebar");
  const overlay = document.getElementById("filtersOverlay");

  const sortChecks = Array.from(document.querySelectorAll(".filter-sort"));
  const sortDropdown = document.getElementById("sortDropdown");
  const openSortBtn = document.getElementById("openSort");
  let isSyncingState = false;

  /* ==========================
     SIDEBAR
  ========================== */

  function closeFilters() {
    if (!sidebar) return;
    sidebar.classList.add("-p-translate-x-full");
    if (overlay) overlay.classList.add("p-hidden");
    document.body.classList.remove("p-overflow-hidden");
  }

  /* ==========================
     FILTROS ACTIVOS
  ========================== */

  function getActiveCategory() {
    if (categoryChecks.length) {
      const scopedCategoryChecks = categoryChecks.filter(isControlVisible);
      const sourceChecks = scopedCategoryChecks.length
        ? scopedCategoryChecks
        : categoryChecks;

      const selectedCategories = sourceChecks
        .filter((cb) => cb.checked)
        .map((cb) => cb.getAttribute("data-filter"))
        .filter(Boolean);

      if (!selectedCategories.length) {
        return ["all"];
      }

      return [selectedCategories[0]];
    }

    if (wayChecks.length) {
      const scopedWayChecks = wayChecks.filter(isControlVisible);
      const sourceChecks = scopedWayChecks.length ? scopedWayChecks : wayChecks;

      const selectedWays = sourceChecks
        .filter((cb) => cb.checked)
        .map((cb) => cb.getAttribute("data-filter"));

      if (!selectedWays.length || selectedWays.includes("all")) {
        return ["all"];
      }

      return selectedWays;
    }

    const activeButton = document.querySelector(".filter-button.p-bg-primary");
    const selected = activeButton
      ? activeButton.getAttribute("data-filter")
      : "all";

    return [selected];
  }

  function getActiveModalities() {
    const scopedModalities = modalities.filter(isControlVisible);
    const sourceModalities = scopedModalities.length
      ? scopedModalities
      : modalities;

    return sourceModalities
      .filter((cb) => cb.checked)
      .map((cb) => cb.getAttribute("data-filter"));
  }

  function readRangeFromWrap(wrap) {
    const minEl = wrap.querySelector(".js-range-bar-min");
    const maxEl = wrap.querySelector(".js-range-bar-max");

    if (!minEl || !maxEl) return null;

    const isReady = wrap.dataset.ready === "1";
    const minRaw =
      isReady && minEl.value !== ""
        ? minEl.value
        : wrap.dataset.min !== undefined
          ? wrap.dataset.min
          : minEl.min;
    const maxRaw =
      isReady && maxEl.value !== ""
        ? maxEl.value
        : wrap.dataset.max !== undefined
          ? wrap.dataset.max
          : maxEl.max;

    const min = Number(minRaw);
    const max = Number(maxRaw);
    const field = (wrap.dataset.field || "price").trim();

    if (!field || !Number.isFinite(min) || !Number.isFinite(max)) {
      return null;
    }

    return { field, min, max };
  }

  function getActiveRanges() {
    const rangesByField = new Map();

    rangeWraps.forEach((wrap) => {
      const range = readRangeFromWrap(wrap);
      if (!range) return;

      const visible = isControlVisible(wrap);
      const current = rangesByField.get(range.field);

      if (!current || (visible && !current.visible)) {
        rangesByField.set(range.field, { ...range, visible });
      }
    });

    return Array.from(rangesByField.values()).map(({ field, min, max }) => ({
      field,
      min,
      max,
    }));
  }

  function parseNumericValue(raw) {
    if (raw === null || raw === undefined) return null;
    if (typeof raw === "number") return Number.isFinite(raw) ? raw : null;

    const text = String(raw).trim();
    if (!text) return null;

    const compact = text.toLowerCase().replace(/\s+/g, "");
    const durationMatch = compact.match(
      /^(?:(\d+(?:[.,]\d+)?)h)?(?:(\d+(?:[.,]\d+)?)m)?$/
    );
    if (durationMatch && (durationMatch[1] || durationMatch[2])) {
      const hours = Number((durationMatch[1] || "0").replace(",", "."));
      const minutes = Number((durationMatch[2] || "0").replace(",", "."));
      if (Number.isFinite(hours) && Number.isFinite(minutes)) {
        return hours + minutes / 60;
      }
    }

    const hm = text.match(/^(\d{1,2})(?::(\d{1,2}))?$/);
    if (hm) {
      const h = Number(hm[1]);
      const m = Number(hm[2] || 0);
      if (Number.isFinite(h) && Number.isFinite(m)) {
        return h + m / 60;
      }
    }

    const normalized = text.replace(",", ".");
    const match = normalized.match(/-?\d+(?:\.\d+)?/);
    if (!match) return null;

    const value = Number(match[0]);
    return Number.isFinite(value) ? value : null;
  }

  function parseIntegerDigits(raw) {
    if (raw === null || raw === undefined) return null;
    const digits = String(raw).replace(/[^\d]/g, "");
    if (!digits) return null;
    const value = Number(digits);
    return Number.isFinite(value) ? value : null;
  }

  function getCardPrice(card) {
    if (!card) return null;

    const direct = card.getAttribute("data-price");
    if (direct !== null && direct !== "") {
      const v = parseIntegerDigits(direct);
      return Number.isFinite(v) ? v : null;
    }

    const dataEl = card.querySelector("[data-price]");
    if (dataEl) {
      const v = parseIntegerDigits(dataEl.getAttribute("data-price"));
      return Number.isFinite(v) ? v : null;
    }

    const priceEl = card.querySelector(".p-text-2xl");
    if (!priceEl) return null;

    const num = parseIntegerDigits(priceEl.textContent || "");

    return Number.isFinite(num) ? num : null;
  }

  function getCardFieldValue(card, field) {
    if (field === "price") {
      return getCardPrice(card);
    }

    const attrName = "data-" + field;

    const direct = card.getAttribute(attrName);
    const directValue = parseNumericValue(direct);
    if (Number.isFinite(directValue)) return directValue;

    const dataEl = card.querySelector("[" + attrName + "]");
    if (dataEl) {
      const attrValue = parseNumericValue(dataEl.getAttribute(attrName));
      if (Number.isFinite(attrValue)) return attrValue;
    }

    const fieldEl = card.querySelector('[data-field="' + field + '"]');
    if (fieldEl) {
      const dataValue = parseNumericValue(fieldEl.getAttribute("data-value"));
      if (Number.isFinite(dataValue)) return dataValue;

      const textValue = parseNumericValue(fieldEl.textContent || "");
      if (Number.isFinite(textValue)) return textValue;
    }

    const classEl = card.querySelector("." + field);
    if (classEl) {
      const dataValue = parseNumericValue(classEl.getAttribute("data-value"));
      if (Number.isFinite(dataValue)) return dataValue;

      const textValue = parseNumericValue(classEl.textContent || "");
      if (Number.isFinite(textValue)) return textValue;
    }

    return null;
  }

  function cardMatchesCategories(card, activeCategories) {
    if (activeCategories.includes("all")) {
      return true;
    }

    const raw = (card.getAttribute("data-category") || "").trim();
    if (!raw) {
      return false;
    }

    const cardCategories = raw.split(/\s+/).filter(Boolean);
    if (!cardCategories.length) {
      return false;
    }

    return activeCategories.some((category) => cardCategories.includes(category));
  }

  function isCardInActiveLayout(card) {
    if (!card || card.classList.contains("p-hidden")) {
      return false;
    }

    // Handles elements hidden by responsive parent containers (display: none).
    const hasLayoutBox = card.getClientRects().length > 0;
    const hasOffsetParent = card.offsetParent !== null;

    return hasLayoutBox || hasOffsetParent;
  }

  function isControlVisible(control) {
    if (!control) return false;
    if (window.getComputedStyle(control).display === "none") return false;
    return control.getClientRects().length > 0 || control.offsetParent !== null;
  }

  function setSortControlActive(sortValue) {
    sortChecks.forEach((item) => {
      const active = item.getAttribute("data-sort") === sortValue;
      const isInput =
        item.tagName === "INPUT" ||
        item.type === "checkbox" ||
        item.type === "radio";

      if (isInput) {
        item.checked = active;
        return;
      }

      item.classList.toggle("is-active", active);
      item.classList.toggle("p-border-2", active);
      item.classList.toggle("p-border", !active);
      item.classList.toggle("p-border-primary", active);
      item.classList.toggle("p-bg-light", active);
      item.classList.toggle("p-text-gray-dark", active);
      item.classList.toggle("p-border-gray-border", !active);
      item.classList.toggle("p-bg-white", !active);
      item.classList.toggle("p-text-gray", !active);
    });
  }

  function getActiveSortControl() {
    const activeButton = sortChecks.find(
      (item) => isControlVisible(item) && item.classList.contains("is-active")
    );
    if (activeButton) return activeButton;

    const activeInput = sortChecks.find(
      (item) => isControlVisible(item) && item.checked
    );
    if (activeInput) return activeInput;

    return null;
  }

  function getActiveSortValue() {
    const activeSort = getActiveSortControl();
    if (!activeSort) return "popular";
    return activeSort.getAttribute("data-sort") || "popular";
  }

  function captureFilterState() {
    return {
      categories: getActiveCategory(),
      modalities: getActiveModalities(),
      ranges: getActiveRanges(),
      sort: getActiveSortValue(),
    };
  }

  function applyCategoriesToControls(categories) {
    if (categoryChecks.length) {
      const selected = (categories || []).find((item) => item !== "all");
      categoryChecks.forEach((cb) => {
        cb.checked = !!selected && cb.getAttribute("data-filter") === selected;
      });
      return;
    }

    const set = new Set(categories || []);
    const useAll = !set.size || set.has("all");
    const groups = new Set(wayChecks.map((cb) => cb.closest("#filter-way")));

    groups.forEach((group) => {
      const scoped = wayChecks.filter((cb) => cb.closest("#filter-way") === group);
      if (!scoped.length) return;

      const allCheck = scoped.find((cb) => cb.getAttribute("data-filter") === "all");

      if (useAll) {
        scoped.forEach((cb) => {
          cb.checked = cb === allCheck;
        });
        return;
      }

      let hasSpecificChecked = false;
      scoped.forEach((cb) => {
        const key = cb.getAttribute("data-filter");
        const checked = key !== "all" && set.has(key);
        cb.checked = checked;
        if (checked) hasSpecificChecked = true;
      });

      if (allCheck) {
        allCheck.checked = !hasSpecificChecked;
      }
    });
  }

  function applyModalitiesToControls(modalitiesState) {
    const set = new Set(modalitiesState || []);
    modalities.forEach((cb) => {
      cb.checked = set.has(cb.getAttribute("data-filter"));
    });
  }

  function applyRangesToControls(rangesState) {
    const byField = new Map((rangesState || []).map((range) => [range.field, range]));

    rangeWraps.forEach((wrap) => {
      const field = (wrap.dataset.field || "price").trim();
      const state = byField.get(field);
      if (!state) return;

      const minRange = wrap.querySelector(".js-range-bar-min");
      const maxRange = wrap.querySelector(".js-range-bar-max");
      if (!minRange || !maxRange) return;

      const nextMin = String(state.min);
      const nextMax = String(state.max);
      const changed = minRange.value !== nextMin || maxRange.value !== nextMax;

      minRange.value = nextMin;
      maxRange.value = nextMax;

      if (changed) {
        minRange.dispatchEvent(new Event("input", { bubbles: true }));
        maxRange.dispatchEvent(new Event("input", { bubbles: true }));
      }
    });
  }

  function syncControlsFromState(state) {
    if (!state) return;

    isSyncingState = true;
    applyCategoriesToControls(state.categories);
    applyModalitiesToControls(state.modalities);
    applyRangesToControls(state.ranges);
    setSortControlActive(state.sort || "popular");
    isSyncingState = false;
  }

  function applyFiltersAndSyncControls() {
    const state = captureFilterState();
    syncControlsFromState(state);
    applyFilters();
  }

  function resetRangeControls() {
    rangeWraps.forEach((wrap) => {
      const minRange = wrap.querySelector(".js-range-bar-min");
      const maxRange = wrap.querySelector(".js-range-bar-max");

      if (!minRange || !maxRange) return;

      const min = Number(
        wrap.dataset.min != null ? wrap.dataset.min : minRange.min
      );

      const max = Number(
        wrap.dataset.max != null ? wrap.dataset.max : maxRange.max
      );

      if (!Number.isFinite(min) || !Number.isFinite(max)) return;

      minRange.value = min;
      maxRange.value = max;

      minRange.dispatchEvent(new Event("input", { bubbles: true }));
      maxRange.dispatchEvent(new Event("input", { bubbles: true }));
    });
  }

  function resetFiltersToInitialState() {
    if (buttons.length) {
      buttons.forEach((btn) =>
        btn.classList.remove("p-bg-primary", "p-text-white", "p-border-0")
      );

      const defaultButton =
        buttons.find((btn) => btn.getAttribute("data-filter") === "all") ||
        buttons[0];
      if (defaultButton) {
        defaultButton.classList.add("p-bg-primary", "p-text-white", "p-border-0");
      }
    }

    modalities.forEach((cb) => {
      cb.checked = false;
    });

    const wayGroups = new Set(wayChecks.map((cb) => cb.closest("#filter-way")));
    wayGroups.forEach((group) => {
      const scoped = wayChecks.filter((cb) => cb.closest("#filter-way") === group);
      if (!scoped.length) return;

      const allCheck = scoped.find((cb) => cb.getAttribute("data-filter") === "all");
      scoped.forEach((cb) => {
        cb.checked = cb === allCheck;
      });
    });

    categoryChecks.forEach((cb) => {
      cb.checked = false;
    });

    resetRangeControls();
    setSortControlActive("popular");
    applyFiltersAndSyncControls();
  }

  /* ==========================
     ORDENAR
  ========================== */

  function applySorting() {
    const activeSort = getActiveSortControl();
    if (!activeSort) return;

    const sortType = activeSort.getAttribute("data-sort");

    const visibleCards = cards.filter(
      (card) =>
        !card.classList.contains("p-hidden") && isCardInActiveLayout(card)
    );

    if (!visibleCards.length) return;

    const sortFieldHint = (activeSort.getAttribute("data-sort-field") || "").trim();
    const hasDurationValues = visibleCards.some((card) =>
      Number.isFinite(getCardFieldValue(card, "duration"))
    );
    const rangeSortField = sortFieldHint || (hasDurationValues ? "duration" : "nights");

    visibleCards.sort((a, b) => {
      const priceA = getCardPrice(a) || 0;
      const priceB = getCardPrice(b) || 0;

      const scoreA = getCardFieldValue(a, "score") || 0;
      const scoreB = getCardFieldValue(b, "score") || 0;

      const rangeA = getCardFieldValue(a, rangeSortField) || 0;
      const rangeB = getCardFieldValue(b, rangeSortField) || 0;

      const popularA = getCardFieldValue(a, "popular");
      const popularB = getCardFieldValue(b, "popular");
      const safePopularA = Number.isFinite(popularA)
        ? popularA
        : Number.MAX_SAFE_INTEGER;
      const safePopularB = Number.isFinite(popularB)
        ? popularB
        : Number.MAX_SAFE_INTEGER;

      switch (sortType) {
        case "popular":
          return safePopularA - safePopularB;

        case "price_asc":
          return priceA - priceB;

        case "price_desc":
          return priceB - priceA;

        case "score_desc":
          return scoreB - scoreA;

        case "rating_desc":
          return scoreB - scoreA;

        case "nights_asc":
          return rangeA - rangeB;

        case "nights_desc":
          return rangeB - rangeA;

        default:
          return 0;
      }
    });

    const container = visibleCards[0].parentNode;

    visibleCards.forEach((card) => {
      container.appendChild(card);
    });
  }

  /* ==========================
     FILTRADO + CONTADOR
  ========================== */

  function applyFilters() {
    if (isSyncingState) return;

    const activeCategories = getActiveCategory();
    const activeModalities = getActiveModalities();
    const activeRanges = getActiveRanges();

    let visibleCount = 0;

    cards.forEach((card) => {
      const cardMode = card.getAttribute("data-mode");
      const matchCategory = cardMatchesCategories(card, activeCategories);

      const matchMode =
        activeModalities.length === 0 ||
        activeModalities.includes(cardMode);

      const matchRanges = activeRanges.every((range) => {
        const value = getCardFieldValue(card, range.field);
        return (
          Number.isFinite(value) && value >= range.min && value <= range.max
        );
      });

      if (matchCategory && matchMode && matchRanges) {
        card.classList.remove("p-hidden");
        if (isCardInActiveLayout(card)) {
          visibleCount++;
        }
      } else {
        card.classList.add("p-hidden");
      }
    });

    applySorting();
    updateButton(visibleCount);
  }

  function updateButton(count) {
    if (!applyBtn) return;

    const labelPrefix = (applyBtn.dataset.labelPrefix || "Ver").trim();
    const labelSingular = (applyBtn.dataset.labelSingular || "actividad").trim();
    const labelPlural = (applyBtn.dataset.labelPlural || "actividades").trim();
    const labelNoResults = (applyBtn.dataset.labelNoResults || "No hay actividades").trim();

    if (count === 0) {
      applyBtn.disabled = true;
      applyBtn.textContent = labelNoResults;
      return;
    }

    applyBtn.disabled = false;

    const label = count === 1 ? labelSingular : labelPlural;
    applyBtn.textContent = labelPrefix + " " + count + " " + label;
  }

  /* ==========================
     EVENTOS ORDENAR
  ========================== */

  if (openSortBtn && sortDropdown) {
    openSortBtn.addEventListener("click", function () {
      sortDropdown.classList.toggle("p-hidden");
    });
  }

  sortChecks.forEach((check) => {
    const isInput =
      check.tagName === "INPUT" ||
      check.type === "checkbox" ||
      check.type === "radio";
    const eventName = isInput ? "change" : "click";

    check.addEventListener(eventName, function () {
      setSortControlActive(check.getAttribute("data-sort"));
      applyFiltersAndSyncControls();
    });
  });

  /* ==========================
     EVENTOS FILTROS
  ========================== */

  buttons.forEach((button) => {
    button.addEventListener("click", function () {
      buttons.forEach((btn) =>
        btn.classList.remove("p-bg-primary", "p-text-white", "p-border-0")
      );
      button.classList.add("p-bg-primary", "p-text-white", "p-border-0");
      applyFiltersAndSyncControls();
    });
  });

  wayChecks.forEach((check) => {
    check.addEventListener("change", function () {
      const changed = check.getAttribute("data-filter");
      const parentFilter = check.closest("#filter-way");
      const scopedWayChecks = wayChecks.filter(
        (cb) => cb.closest("#filter-way") === parentFilter
      );
      const sourceChecks = scopedWayChecks.length ? scopedWayChecks : wayChecks;

      if (changed === "all" && check.checked) {
        sourceChecks.forEach((cb) => {
          if (cb !== check) cb.checked = false;
        });
      }

      if (changed !== "all" && check.checked) {
        const allCheck = sourceChecks.find(
          (cb) => cb.getAttribute("data-filter") === "all"
        );
        if (allCheck) allCheck.checked = false;
      }

      const selectedSpecific = sourceChecks.filter(
        (cb) =>
          cb.checked && cb.getAttribute("data-filter") !== "all"
      );

      if (!selectedSpecific.length) {
        const allCheck = sourceChecks.find(
          (cb) => cb.getAttribute("data-filter") === "all"
        );
        if (allCheck) allCheck.checked = true;
      }

      applyFiltersAndSyncControls();
    });
  });

  categoryChecks.forEach((check) => {
    check.addEventListener("change", function () {
      if (check.checked) {
        categoryChecks.forEach((cb) => {
          if (cb !== check) cb.checked = false;
        });
      }

      applyFiltersAndSyncControls();
    });
  });

  modalities.forEach((modality) => {
    modality.addEventListener("change", applyFiltersAndSyncControls);
  });

  document.addEventListener("range-bar:change", applyFilters);

  let resizeTimer = null;
  window.addEventListener("resize", function () {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(applyFiltersAndSyncControls, 120);
  });

  if (applyBtn) {
    applyBtn.addEventListener("click", function () {
      closeFilters();
    });
  }

  clearFilterButtons.forEach((btn) => {
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      resetFiltersToInitialState();
    });
  });

  /* ==========================
     INIT
  ========================== */

  window.applyFilters = applyFilters;
  window.syncFilterControls = applyFiltersAndSyncControls;
  applyFiltersAndSyncControls();
});

